export const workScheduleTypeOptions = [
  { value: 'ordinary', label: 'Jornada ordinaria' },
  { value: 'ordinary_biweekly', label: 'Jornada bisemanal ordinaria' },
  { value: 'exceptional', label: 'Jornada excepcional' }
]
